import { render } from "./StarIcon.vue?vue&type=template&id=f0d8c776"
const script = {}

import exportComponent from "E:\\TestProject Temurako\\e-commerce-app-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__